module.exports = __webpack_public_path__ + "img/64800.779f4301.jpg";